import * as React from 'react';

import { AUTO_CLOSE_ONBOARDING_DELAY_MS, SHOW_ONBOARDING_DELAY_MS } from '../constants';

interface IUseCompareFlightOnboardingResult {
  isCompareFlightOnboardingOpen: boolean;
  closeHandler(): void;
}

export function useCompareFlightOnboarding(enabled: boolean): IUseCompareFlightOnboardingResult {
  const [isCompareFlightOnboardingOpen, setIsCompareFlightOnboardingOpen] = React.useState(false);

  const closeHandler = React.useCallback(() => {
    setIsCompareFlightOnboardingOpen(false);
  }, []);

  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    const timerId = setTimeout(() => setIsCompareFlightOnboardingOpen(true), SHOW_ONBOARDING_DELAY_MS);

    return () => clearTimeout(timerId);
  }, [enabled]);

  React.useEffect(() => {
    if (!isCompareFlightOnboardingOpen) {
      return;
    }

    const timerId = setTimeout(closeHandler, AUTO_CLOSE_ONBOARDING_DELAY_MS);
    const closeByDocumentClick = () => closeHandler();

    document.addEventListener('click', closeByDocumentClick);

    return () => {
      clearTimeout(timerId);
      document.removeEventListener('click', closeByDocumentClick);
    };
  }, [closeHandler, isCompareFlightOnboardingOpen]);

  return { isCompareFlightOnboardingOpen, closeHandler };
}
